import React from 'react';
import {
  leadCategoryPillClassName,
  leadCategorySwatchClassName,
  leadCategoryTextClassName,
} from '../utils/leadCategoryColors';

type LeadCategoryBadgeProps = {
  label: string | null | undefined;
  color?: string | null;
  size?: 'xs' | 'sm';
  bold?: boolean;
  /**
   * `text` färbt die Schrift ein (kompakte Stellen).
   * `dot` setzt einen farbigen Punkt vor neutralen Text (Listen).
   * `pill` Soft-Tag mit hellem Hintergrund (Kanban-Karten).
   */
  variant?: 'text' | 'dot' | 'pill';
  className?: string;
};

export function LeadCategoryBadge({
  label,
  color,
  size = 'sm',
  bold = true,
  variant = 'text',
  className = '',
}: LeadCategoryBadgeProps) {
  const text = label != null ? String(label).trim() : '';
  // `xs` bleibt eine Stufe unter `text-xs` — für schmale Flächen wie Kanban-Karten.
  const textSize = size === 'xs' ? 'text-[11px]' : 'text-xs';

  if (!text) {
    return <span className={`text-app-text-subtle ${textSize} ${className}`}>—</span>;
  }

  if (variant === 'pill') {
    return (
      <span
        title={text}
        className={`inline-flex max-w-full items-center truncate rounded-full px-2 py-0.5 font-medium whitespace-nowrap ring-1 ring-inset ${textSize} ${leadCategoryPillClassName(color)} ${className}`}
      >
        {text}
      </span>
    );
  }

  if (variant === 'dot') {
    return (
      <span className={`inline-flex min-w-0 items-center gap-1.5 ${textSize} ${className}`} title={text}>
        <span
          className={`h-1.5 w-1.5 shrink-0 rounded-full ${leadCategorySwatchClassName(color)}`}
          aria-hidden
        />
        <span className="truncate text-app-text-muted">{text}</span>
      </span>
    );
  }

  const sizeClass = size === 'xs' ? 'text-[11px] max-w-[72px]' : 'text-xs max-w-[96px]';
  return (
    <span
      className={`inline-flex items-center truncate ${bold ? 'font-semibold' : 'font-normal'} ${leadCategoryTextClassName(color)} ${sizeClass} ${className}`}
      title={text}
    >
      {text}
    </span>
  );
}
